import * as CONSTS from '../_config/Consts';

export type D = {width: number, height: number}
export default class Dimensions {
	
	// This needs to limit module sizes so that no module can span more than 2x document size in any direction
	// This is because the shaders do not handle more for overlaps
	static getModuleMaxDimensions(width:number, height:number, documentWidth:number, documentHeight:number):D {
		// Method 1 math - mostly copied from the old limits on the transformer, but with the right values - as of 2023 this is magic to me
		const ratio:number = (width ** 2) / (height ** 2)
		const h:number = ((Math.max(documentWidth, documentHeight) * 2) ** 2) / (ratio + 1)
		return {width: Math.round((h*ratio) ** 0.5), height: Math.round((h) ** 0.5)}
		
		// Method 3 no math
		//return {width: documentWidth * 2, height: documentHeight * 2}
	}

	static getRenderDimensions = (documentWidth:number, documentHeight:number):D => {
		let width = Dimensions.getRenderWidth(documentWidth, documentHeight);
		let height = Dimensions.getRenderHeight(documentWidth, documentHeight);
		let DPI = Math.min(width / documentWidth, height / documentHeight);
		return {
			width: documentWidth * DPI,
			height: documentHeight * DPI,
		};
	}

	//The WEBGL_MAX_SIZE should be calculated based on gl.getParameter(gl.MAX_TEXTURE_SIZE). It also has to be divided by 3 for the TileNine
	static getRenderWidth = (documentWidth:number, documentHeight:number) => Math.round(Math.min(Math.floor(CONSTS.WEBGL_MAX_SIZE), Math.sqrt(CONSTS.DOCUMENT_MAX_PIXELS * (documentWidth / documentHeight))))
	static getRenderHeight = (documentWidth:number, documentHeight:number) => Math.round(Math.min(Math.floor(CONSTS.WEBGL_MAX_SIZE), Math.sqrt(CONSTS.DOCUMENT_MAX_PIXELS / (documentWidth / documentHeight))))

	static getMinDPI = (documentWidth:number, documentHeight:number):number => {
		let windowWidth:number = 1920;
		let windowHeight:number = 1080;

		//Adjust viewer dpi 
		return Math.max(
			Math.min(CONSTS.DOCUMENT_DATA_DPI, windowWidth / CONSTS.DOCUMENT_MAX_REPEAT / (documentWidth / CONSTS.DOCUMENT_DATA_DPI)), 
			Math.min(CONSTS.DOCUMENT_DATA_DPI, windowHeight / CONSTS.DOCUMENT_MAX_REPEAT / (documentHeight / CONSTS.DOCUMENT_DATA_DPI))
		); 
	}

	static getMaxDPI = (documentWidth:number, documentHeight:number):number => {
		let windowWidth:number = 1920;
		let windowHeight:number = 1080;

		//Adjust viewer dpi 
		return Math.min(
			windowWidth / CONSTS.DOCUMENT_MIN_REPEAT / documentWidth * CONSTS.DOCUMENT_DATA_DPI,
			windowHeight / CONSTS.DOCUMENT_MIN_REPEAT / documentHeight * CONSTS.DOCUMENT_DATA_DPI
		);
	}

	static calcDPI = (newDpi:number, width: number, height: number):number => {
		return Math.min(
			Dimensions.getMaxDPI(width, height),
			Math.max(
				Dimensions.getMinDPI(width, height),
				newDpi
			)
		);
	}
}